export enum TrackingEvent {
    AddToCart = 'AddToCart',
    AddPaymentInfo = 'AddPaymentInfo',
    CompleteRegistration = 'CompleteRegistration',
    FindLocation = 'FindLocation',
    InitiateCheckout = 'InitiateCheckout',
    Purchase = 'Purchase',
    ViewContent = 'ViewContent',
}